import { Link } from 'react-router-dom'

export default function DoubleButton(props) {

  return (
    // Wrapper
    <div className="flex flex-wrap -mx-3 mb-4">

      {/* First Button */}
      {props.color ? (
        <div className="w-full md:w-1/2 px-3 mb-4 md:mb-0">
          <button style={{ backgroundColor: props.color }} onClick={props.prevStep} className={`w-full text-white focus:ring-4 focus:outline-none font-medium rounded-lg text-sm px-5 py-2.5 text-center`}>Prev</button>
        </div>
      ) : (
        <div className="w-full md:w-1/2 px-3 mb-4 md:mb-0">
          <button onClick={props.prevStep} className={`w-full text-white bg-primary-200 hover:bg-primary-300 focus:ring-4 focus:outline-none font-medium rounded-lg text-sm px-5 py-2.5 text-center`}>Prev</button>
        </div>
      )}
      
      {/* Second Button */}
      {props.color ? (
        <div className="w-full md:w-1/2 px-3">
          <button type="submit" style={{ backgroundColor: props.color }} className={`w-full text-white focus:ring-4 focus:outline-none font-medium rounded-lg text-sm px-5 py-2.5 text-center`}>Next</button>
        </div>
      ) : (
        <div className="w-full md:w-1/2 px-3">
          <button type="submit" className={`w-full text-white bg-primary-200 hover:bg-primary-300 focus:ring-4 focus:outline-none font-medium rounded-lg text-sm px-5 py-2.5 text-center`}>Next</button>
        </div>
      )}
    </div>
  )
}
